import type { VsmContext, PageConfigEntry, PageConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { OnloadCompsBehaviorsPageConfig } from '../types'
import { name } from '../symbols'

const onloadCompsBehaviorsPageConfig: PageConfigFn<OnloadCompsBehaviorsPageConfig> = ({ api }: VsmContext) => {
	const matchingComps = api.components.getComponentsByPredicate((_, compId) => {
		const props = api.components.getCompProps<{ isHidden?: boolean; isCollapsed?: boolean }>(compId)
		return props?.isHidden !== undefined || props?.isCollapsed !== undefined
	})
	const compsBehaviors: OnloadCompsBehaviorsPageConfig['compsBehaviors'] = {}

	for (const compId of Object.keys(matchingComps)) {
		const props = api.components.getCompProps<{ isHidden?: boolean; isCollapsed?: boolean }>(compId)!
		compsBehaviors[compId] = {
			hiddenOnLoad: props.isHidden,
			collapseOnLoad: props.isCollapsed,
			isResponsiveComponent: api.components.hasResponsiveLayout(compId),
		}
	}

	if (Object.keys(compsBehaviors).length === 0) {
		return { shouldLoadPageFeature: false }
	}

	return {
		shouldLoadPageFeature: true,
		pageConfig: { compsBehaviors },
	}
}

export const pageConfig: PageConfigEntry<OnloadCompsBehaviorsPageConfig> = {
	name,
	configFactory: onloadCompsBehaviorsPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
